module.exports = __webpack_public_path__ + "img/TECHNOLOGY-BALENO-4.ac4f690d.jpg";